export default class Mutations {
    static DEFINE_PREVIEW = 'DEFINE_PREVIEW';
    static DEFINE_MODULOS = 'DEFINE_MODULOS';
    static DEFINE_DADOS_ATENDIMENTO = 'DEFINE_DADOS_ATENDIMENTO';
    static DEFINE_DADOS_PRESTADOR = 'DEFINE_DADOS_PRESTADOR';
    static DEFINE_CHECKLIST_RESPOSTA = 'DEFINE_CHECKLIST_RESPOSTA';
    static DEFINE_RECEBIMENTO_FINALIZADO = 'DEFINE_RECEBIMENTO_FINALIZADO';
    static DEFINE_ETAPA_SALVA = 'DEFINE_ETAPA_SALVA';
    static DEFINE_IMAGENS = 'DEFINE_IMAGENS';
    static DEFINE_TIPO_VEICULO = 'DEFINE_TIPO_VEICULO';
    static DEFINE_COORDENADAS_TEMP = 'DEFINE_COORDENADAS_TEMP';
}
